export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const throttle = (fn: (...args: any[]) => void, delay: number) => {
  let isActive = true;
  let savedArgs: any[] | null = null;
  const wrapper = (...args: any[]) => {
    if (!isActive) {
      return (savedArgs = args);
    }

    isActive = false;
    fn(...args);

    setTimeout(() => {
      isActive = true;
      if (savedArgs) {
        wrapper(...savedArgs);
        savedArgs = null;
      }
    }, delay);
  };
  return wrapper;
};
